import Joi from 'joi';
import { userFormSchema } from '../../utils/schemas';

export const createCustomerSchema = Joi.object({
  ...userFormSchema,
  role: Joi.string().optional(),
  date: Joi.any(),
  vessels: Joi.any(),
  assignedVessels: Joi.any(),
  ownedVessels: Joi.any()
}).options({
  abortEarly: false
});

export const updateCustomerSchema = Joi.object({
  ...userFormSchema,
  role: Joi.string().optional(),
  date: Joi.any(),
  vessels: Joi.any(),
  assignedVessels: Joi.any(),
  ownedVessels: Joi.any()
}).options({
  abortEarly: false
});
